// extracted by mini-css-extract-plugin
export default {"half":"AnimationProperty_half__Lf+AQ"};